















import { mapGetters } from "vuex";

export default {
  name: "FloatingButton",
  props: {
    bottom: {
      type: String,
      default: "130px"
    },

    right: {
      type: String,
      default: "30px"
    },

    icon: {
      type: String,
      required: true
    },

    action: {
      type: Function,
      default: () => null
    },

    tooltipMessage: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  }
};
